@import "./uiaas-compare-bar-mixins.scss";
@import "./partials/compare-message.scss";
@import "./partials/compare-comparison.scss";
@import "./partials/compare-clean.scss";

.compare-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 50;

  &-bar {
    @include smallCompareBar;

    align-items: center;
    background-color: $svs-sunflower-yellow;
    box-sizing: border-box;
    color: $svs-black;
    display: flex;
    text-decoration: none;

    @media (min-width: 780px) {
      cursor: unset;
      height: 88px;
      padding: 20px 130px;
    }

    @media only screen and (min-width: 780px) and (max-width: 1080px) {
      padding: 20px 30px;
    }

    &-information {
      align-items: center;
      display: flex;

      @media (max-width: 780px) {
        @include spaceBetween;
      }

      section {
        align-items: center;
        display: flex;
      }

      &__text {
        line-height: 25px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;

        @media (max-width: 780px) {
          @include informationSmallerSpacing;
          white-space: unset;
        }
      }

      &__counter {
        margin-left: 6px;
        margin-right: 16px;

        @media (max-width: 1080px) {
          margin-right: 24px;
        }

        @media (max-width: 780px) {
          margin-right: 20px;
        }
      }
    }
  }
}

.compare-wrapper--not-product-related-tab {
  @media (min-width: 780px) {
    bottom: 17px;
    left: 50%;
    transform: translate(-50%, 0);
    width: max-content;
  }

  .compare-wrapper {
    &-bar {
      @include smallCompareBar;

      @media (min-width: 780px) {
        border-radius: 4px;
        cursor: unset;
        width: max-content;
      }

      &-icon {
        cursor: pointer;
      }

      &-information {
        @include spaceBetween;

        &__text {
          @include informationSmallerSpacing;
        }

        &__counter {
          @media (min-width: 780px) {
            margin-right: 20px;
          }
        }
      }
    }
  }
}
